/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat, Ian Morland.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionListState, { type DiscussionListParams } from 'flarum/forum/states/DiscussionListState';

/**
 * `PaginatedListState.params` is `protected`, so it is not reachable through the
 * `this` type `extend` hands to its callback.
 */
export interface DiscussionListStateParams {
	params: DiscussionListParams;
}

export default function () {
	extend(DiscussionListState.prototype, 'requestParams', function (params) {
		if (app?.session?.user?.canFilterNoAnswer()) {
			if ((this as unknown as DiscussionListStateParams).params.sort === 'commentCount') {
				(params.filter as Record<string, string>).no_answer = '';
			}
		}
	});
	extend(DiscussionListState.prototype, 'sortMap', function (map: Record<string, string>) {
		if (app?.session?.user?.canFilterNoAnswer()) {
			// Delete Mapping
			delete map.top;
			delete map.newest;
			delete map.oldest;

			// Re-Add Mapping to Redo Sort Order
			map.commentCount = 'commentCount';
			map.top = '-commentCount';
			map.newest = '-createdAt';
			map.oldest = 'createdAt';
		}
	});
}
